<div class="unauthorised">
  <div class="mat-headline-6 unauthorised-title">
    You have tried to access data or operations for which you are not authorised.
  </div>
  <div class="mat-headline-6 unauthorised-title" style="color: red; font-weight: bold">Please contact a system adminstrator or try again with another account.</div>
  <a href="#" (click)="logout()"  class="mat-body-2">Log out and try again.</a>
</div>
